import React from "react";
import defaultAvatar from "../../assets/images/users/avatar-1.png";

const getUserAvatar = (user) => {
  const image = [
    user?.profilePictureUrl,
    user?.profileImageUrl,
    user?.profileImage,
    user?.imageUrl,
    user?.photoUrl,
    user?.avatarUrl,
    typeof user?.image === "string" ? user.image : null,
  ].find((value) => typeof value === "string" && value.trim());

  return image || defaultAvatar;
};

const UserAvatar = ({ user, className = "", alt = "Profile" }) => (
  <img
    className={className}
    src={getUserAvatar(user)}
    alt={alt}
    onError={(event) => {
      event.currentTarget.src = defaultAvatar;
    }}
  />
);

export { getUserAvatar };
export default UserAvatar;
